<template>
  <div class="single__preview">
    <div class="single__preview-main">

      <div v-if="product.prices.is_active_discount" class="label label--lg label--discount">
        {{ in18['page_discount'] }}
      </div>
      <div v-else-if="product.is_popular" class="label label--lg label--top">
        {{ in18['page_popular'] }}
      </div>
      <div v-else-if="product.is_new" class="label label--lg label--new">
        {{ in18['page_new'] }}
      </div>

      <div class="single__preview-main-container">
        <div :key="product" id="productPreview" class="single__preview-slider">
          <a v-for="image, i in largeImages" :title="product.title" @click="openImageGallery(i)" class="w-full h-full">
            <picture>
              <source :srcset="image.webp" type="image/webp">
              <img :alt="product.title" :src="image?.source" class="w-full h-full object-contain object-center p-5">
            </picture>
          </a>
        </div>
      </div><!-- /.single__preview-main-container-main -->
    </div><!-- /.single__preview-main -->

    <div :key="product" id="productThumbs" class="single__thumbs">
      <div v-for="image in smallImages" class="slider-item lg:w-[112px] h-[74px] lg:h-[112px] overflow-hidden">
        <picture>
          <source :srcset="image.webp" type="image/webp">
          <img :alt="product.title" :src="image?.source" class="w-full h-full object-contain object-center">
        </picture>
      </div>
    </div><!-- /.single__thumbs -->
  </div><!-- /.single__preview -->
  <image-fullscreen-slider
      ref="galleryRef"
      :imgSrcList="imageList"
  />
</template>

<script>

export default {
  name:  'ProductPreviewGallery',
  props: {
    product: Object,
    in18:    {
      type: Object,
    },
  },

  mounted() {
    // Initialize sliders on component mount
    this.initializeSliders();
  },

  computed: {
    //return list of image sources
    imageList() {
      return this.product.images.large.map((i) => {
        return i.source;
      });
    },
    largeImages() {
      return this.product.images.large
    },
    smallImages() {
      return this.product.images.small
    }
  },
  methods:  {
    //open gallery with selected image index
    openImageGallery(i) {
      this.$refs.galleryRef.openGallery(i);
    },

    initializeSliders() {
      // Destroy existing sliders if they exist
      if (this.productSlider) {
        this.productSlider.slick('unslick');
      }
      if (this.thumbsSlider) {
        this.thumbsSlider.slick('unslick');
      }

      // Reinitialize the sliders
      this.initProductSlider();
      this.initThumbsSlider();
    },

    initProductSlider() {
      this.productSlider = $('#productPreview').slick({
        infinite:       true,
        slidesToShow:   1,
        slidesToScroll: 1,
        fade:           true,
        arrows:         true,
        asNavFor:       '#productThumbs',
        lazyLoad:       'ondemand',
      });
    },

    initThumbsSlider() {
      this.thumbsSlider = $('#productThumbs').slick({
        infinite:       true,
        slidesToShow:   4,
        slidesToScroll: 1,
        fade:           false,
        arrows:         true,
        asNavFor:       '#productPreview',
        focusOnSelect:  true,
        lazyLoad:       'ondemand',
      });
    },
  },
  data() {
    return {
      productSlider: null,
      thumbsSlider:  null,
    };
  },
}
</script>